import { ProfileImage } from '../../../types/api/ImageType';
import ILink from '../../../types/ILink';

export enum PersonInfoCardModifier {
  LIGHT = 'light',
  FIXED_SIZE = 'fixed-size',
}

export type PersonInfoCardData = {
  profileName: string;
  institution: string;
  roleNames: string;
  orgUnit: string;
  profileImageUrl: ProfileImage;
  profileLink: ILink;
  emailLink: ILink;
  phoneLink: ILink;
  room: string | null;
  location: string | null;
};
